export const ATTENDANCE_COLUMNS = [
  { label: 'Employee Name', sortKey: 'employee_name', sortType: 'text' },
  { label: 'Employee ID', sortKey: 'employee_no', sortType: 'text' },
  {
    label: 'Location',
    sortKey: 'location_name',
    sortType: 'category-filter',
    filterParam: 'location_filter',
    searchable: true,
    optionsKey: 'locations',
  },
  { label: 'Check In - Check Out', sortKey: 'check_in_time', sortType: 'time' },
  { label: 'Total Work Time', sortKey: 'day_total_minutes', sortType: 'number' },
  { label: 'Date', sortKey: 'work_date', sortType: 'date' },
  {
    label: 'Shift',
    sortKey: 'effective_shift_name',
    sortType: 'category-filter',
    filterParam: 'shift_filter',
    searchable: true,
    optionsKey: 'shifts',
  },
  { label: 'Min. Work', sortKey: 'min_work_minutes', sortType: 'number' },
  { label: 'Time Short', sortKey: 'time_short_minutes', sortType: 'number' },
  { label: 'Break', sortKey: 'break_duration_minutes', sortType: 'number' },
  { label: 'Late In', sortKey: 'late_checkin_minutes', sortType: 'number' },
  { label: 'Early Leave', sortKey: 'early_leave_minutes', sortType: 'number' },
  { label: 'Overtime', sortKey: 'overtime_minutes', sortType: 'number' },
  {
    label: 'Manager Informed',
    sortKey: 'manager_informed',
    sortType: 'category-filter',
    filterParam: 'manager_informed_filter',
    searchable: false,
    staticOptions: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },
  { label: 'Status', sortKey: 'status', sortType: 'status-filter' },
];

export const ATTENDANCE_STATUS_FILTER_OPTIONS = [
  { label: 'Checked In', value: 'checked_in' },
  { label: 'Checked Out', value: 'checked_out' },
  { label: 'Absent', value: 'absent' },
];

const SORT_LABELS = {
  text: { asc: 'A to Z', desc: 'Z to A' },
  date: { asc: 'Older to newer', desc: 'Newer to older' },
  time: { asc: 'Older to newer', desc: 'Newer to older' },
  number: { asc: 'Low to high', desc: 'High to low' },
  boolean: { asc: 'No to Yes', desc: 'Yes to No' },
};

export function getSortOptions(sortType) {
  const labels = SORT_LABELS[sortType] || SORT_LABELS.text;
  return [
    { order: 'asc', label: labels.asc },
    { order: 'desc', label: labels.desc },
  ];
}
